import React from "react"

import LayoutWithMenu from "../../layouts/LayoutWithMenu";
import { renderRoutes } from "react-router-config";
const GeneralSettingsLayout = ({ route }: { route?: any }) => {
    return <LayoutWithMenu route={route}>
        {renderRoutes(route.routes)}
    </LayoutWithMenu>
};


export default GeneralSettingsLayout